import {Button, Grid, TextField} from "@mui/material";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import React, {useState} from "react";
import {_OrcamentosEndpoints} from "@localization/siteMap/endpoints/_OrcamentosEndpoints.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface RejeitaOrcamentoComponentProps {
    orcamentoId: number,
    onFinish?: () => void
}

export const RejeitaOrcamentoComponent: React.FC<RejeitaOrcamentoComponentProps> = ({orcamentoId, onFinish}) => {
    const [motivo, setMotivo] = useState<string>('');
    const {Get} = useApi()
    const {createAlertFromResponse} = useAlert();


    return (<Grid container spacing={0.5}>
        <Grid size={12}>
            <TextField label={'Motivo da rejeição'}
                       fullWidth value={motivo}
                       onChange={x => {
                           setMotivo(x.target.value);
                       }}/>
        </Grid>
        <Grid size={12}>
            <Button sx={{height: '100%'}}
                    variant={'outlined'}
                    color={'error'}
                    onClick={() => {
                        Get(_OrcamentosEndpoints.RejeitarOrcamento({orcamentoId: orcamentoId, motivo: motivo})).then(x => {
                            createAlertFromResponse(x);
                            if (x.status == 'Success') {
                                if (onFinish) {
                                    onFinish();
                                }
                            }
                        });
                    }}
                    fullWidth>Rejeitar
            </Button>
        </Grid>
    </Grid>);
};